type LabelProps = {
  htmlFor?: string | undefined;
  children: React.ReactNode;
  className?: string | undefined;
  "data-testid"?: string;
};

export function Label({
  htmlFor,
  children,
  className,
  "data-testid": dataTestId = "label"
}: LabelProps) {
  const defaultClass = "mb-[3px] block text-xs font-normal leading-4 text-gray-900 font-inter";
  const finalClass = className || defaultClass;

  return (
    <label htmlFor={htmlFor} className={finalClass} data-testid={dataTestId}>
      {children}
    </label>
  );
}
